module.exports = __webpack_public_path__ + "img/9_13.ac7a7af2.png";